<template>
    <b-card class="w-100">
        <template v-slot:header>
            <div
                style="cursor: pointer;"
                class="d-flex"
                @click="mutableOpen = !mutableOpen"
            >
                {{ title }} <span class="ml-auto"><i
                    class="fas"
                    :class="{'fa-caret-up': mutableOpen, 'fa-caret-down': !mutableOpen}"
                /></span>
            </div>
        </template>
        <b-collapse
            :id="collapseid"
            v-model="mutableOpen"
        >
            <slot>No Content</slot>
        </b-collapse>
    </b-card>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            required: true,
        },
        collapseid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            mutableOpen: this.open,
        };
    },
    computed: {},
    watch: {
        open() {
            this.mutableOpen = this.open;
        },
    },
    mounted() {},
    methods: {},
};

</script>
